import {
	CHANGE_CURRENT_PATH,
	CHANGE_NEXT_PATH,
	CHANGE_SCREEN_SIZE,
} from '../actions';

const initialState = {
	currentPath: '',
	nextPath:'',
	windowWidth:window.innerWidth,
	windowHeight:window.innerHeight,
};

export default function currentPage(state = initialState, action) {
	switch (action.type) {
		case CHANGE_SCREEN_SIZE:
			return Object.assign({}, state, action.payload);
		case CHANGE_CURRENT_PATH:
			return Object.assign({}, state, action.payload);
		case CHANGE_NEXT_PATH:
			return Object.assign({}, state, action.payload);
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/navigation.js